import request from '@/utils/request'
import { cmsServerContext } from '@/config/config'

/**
 * 根据客户id获取菜单树
 * @param customerId
 */
export function getMenuTree(customerId) {
  return request({
    url: cmsServerContext + '/customerMenu/getMenuTree/' + customerId,
    method: 'get'
  })
}

